import React from 'react';
import { Icon } from './Icon.js';
export const IconEnvelope = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2 6V8L12 13L22 8V6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M2 4V20H22V4H2Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconEnvelope.js.map